import { render, staticRenderFns } from "./ModalEdicaoRestricoesCdaWa.vue?vue&type=template&id=d7629bf8&lang=pug"
import script from "./ModalEdicaoRestricoesCdaWa.vue?vue&type=script&lang=js"
export * from "./ModalEdicaoRestricoesCdaWa.vue?vue&type=script&lang=js"
import style0 from "./ModalEdicaoRestricoesCdaWa.vue?vue&type=style&index=0&id=d7629bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports